var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/FollowRow/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import SpotTag from "@mlb/react-patterns/dist/components/SpotTag/spotTag";
import { ButtonShapes, ButtonStyles } from "@mlb/react-patterns/dist/components/Button/button.types";
import { FollowRowContainer } from "./styles";
var ComponentKey = "follow-row";
var defaultFollowButtonProps = {
  shape: ButtonShapes.PILL,
  styleName: ButtonStyles.BLACK
};
var FollowRow = function FollowRow(_ref) {
  var alt = _ref.alt,
    className = _ref.className,
    dark = _ref.dark,
    dataAttr = _ref.dataAttr,
    _ref$followButtonProp = _ref.followButtonProps,
    followButtonProps = _ref$followButtonProp === void 0 ? defaultFollowButtonProps : _ref$followButtonProp,
    followHandlers = _ref.followHandlers,
    _ref$followLabel = _ref.followLabel,
    followLabel = _ref$followLabel === void 0 ? "FOLLOW" : _ref$followLabel,
    id = _ref.id,
    isFavorite = _ref.isFavorite,
    isFollowed = _ref.isFollowed,
    _ref$lazyload = _ref.lazyload,
    lazyload = _ref$lazyload === void 0 ? false : _ref$lazyload,
    name = _ref.name,
    spotTagProps = _ref.spotTagProps,
    superName = _ref.superName,
    type = _ref.type;
  return /*#__PURE__*/React.createElement(FollowRowContainer, _extends({
    className: className,
    dark: dark,
    "data-testid": "".concat(ComponentKey, "--").concat(id),
    isFollowed: isFollowed
  }, dataAttr, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(SpotTag, _extends({
    alt: alt,
    dark: dark,
    followButtonProps: followButtonProps,
    followHandlers: followHandlers,
    followLabel: followLabel,
    id: id,
    isFavorite: isFavorite,
    isFollowed: isFollowed,
    lazyload: lazyload,
    name: name,
    superName: superName === "Athletics" ? "" : superName,
    showFollow: !isFavorite,
    type: type,
    width: 40
  }, spotTagProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  })));
};
export default /*#__PURE__*/React.memo(FollowRow);